import * as angular from 'angular';
import { Injector, NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { workflowConfig } from './store/workflow-config.reducer';
import { CoreModule } from '../core/core.module';
import { WORKFLOW_COMPONENTS, WORKFLOW_SERVICES } from './index';
import { ClickOutsideModule } from 'ng-click-outside';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  imports: [
    CoreModule,
    SharedModule,
    ClickOutsideModule,
    StoreModule.forFeature('workflowConfig', workflowConfig),
  ],
  declarations: [...WORKFLOW_COMPONENTS],
  exports: [...WORKFLOW_COMPONENTS],
  providers: [
    ...WORKFLOW_SERVICES
  ]
})
export class WorkflowConfigModule {
  public static injector: Injector;

  constructor(injector: Injector) {
    WorkflowConfigModule.injector = injector;
  }
}

